import { updateItems } from "@/mocks/site";

function TickerRow({ duplicate }: { duplicate?: boolean }) {
  return (
    <div className="flex shrink-0 items-center gap-6 pr-6" aria-hidden={duplicate ? "true" : undefined}>
      {updateItems.map((item) => (
        <span key={item.id} className="flex items-center gap-2 whitespace-nowrap text-xs md:text-[13px]">
          <span className="flex h-4 w-4 items-center justify-center text-accent-300">
            <i className="ri-flashlight-fill text-[10px]" aria-hidden="true" />
          </span>
          <span className="font-medium text-background-50">{item.title}</span>
          <span className="text-primary-100">{item.note}</span>
          <span className="text-primary-200/80">{item.time}</span>
        </span>
      ))}
    </div>
  );
}

export default function UpdateTicker() {
  return (
    <div className="sticky top-0 z-50 flex h-9 w-full items-center overflow-hidden bg-primary-700">
      <div className="z-10 flex h-full shrink-0 items-center gap-1.5 bg-primary-800 px-3 md:px-4">
        <span className="flex h-4 w-4 items-center justify-center text-accent-300">
          <i className="ri-broadcast-line text-sm" aria-hidden="true" />
        </span>
        <span className="text-xs font-semibold tracking-wide text-background-50">更新条</span>
      </div>
      <div className="ticker-mask relative flex-1 overflow-hidden">
        <div className="flex w-max animate-marquee items-center">
          <TickerRow />
          <TickerRow duplicate />
        </div>
      </div>
    </div>
  );
}